import { Grid, Typography } from '@material-ui/core';
import React from 'react'

const ShowDetails = (props:any) => {
    const {selectedFile} = props;
    return (
        <Grid>
            <Typography align='center' component="span">File Name : {selectedFile?.name}</Typography>
        </Grid>
    )
}

export default ShowDetails;